import { Component, effect, inject, input, output, signal, ViewChild } from '@angular/core';
import { SecondHandService } from '../../../services/second-hand.service';
import { Router, RouterModule } from '@angular/router';
import { SlickCarouselComponent, SlickCarouselModule } from 'ngx-slick-carousel';
import { UsedCategory } from '../../models/used-category.model';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-used-carousel',
  imports: [CommonModule, NgOptimizedImage, RouterModule, SlickCarouselModule],
  templateUrl: './used-carousel.component.html',
  styleUrl: './used-carousel.component.scss',
})
export class UsedCarouselComponent {
  private secondHandService = inject(SecondHandService);
  private router = inject(Router);

  @ViewChild('carouselUsedHome')
  slickModal?: SlickCarouselComponent;

  nextPrev = input<string>();
  countEquipment = output<number>();

  usedCategories = signal<UsedCategory[]>([]);

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  constructor() {
    this.getCategories();

    effect(() => {
      const action = this.nextPrev();
      if (!action) return;

      if (action === 'next') {
        this.slickModal?.slickNext();
      } else {
        this.slickModal?.slickPrev();
      }
    });
  }

  getCategories() {
    this.secondHandService.getCategoriesHome().subscribe({
      next: (result) => {
        this.usedCategories.set(result);
        this.countEquipment.emit(result.length);
      },
    });
  }

  goToDetail(category: UsedCategory) {
    this.router.navigate(['/equipo-usado/categorias', category.category.slug, category.slug]);
  }
}
